@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="rtnav ui-g">
  <div class="ui-g-6 msgbox-6">
    @for (message of msgsPoeSurvey; track message) {
      <p-message [life]="3000" [text]="message.detail"></p-message>
    }
  </div>
  @if (!btnNavPoeSurvey) {
    <div class="ui-g-5"></div>
  }
  @if (btnNavPoeSurvey) {
    <div class="ui-g-5">
      <button
        type="button"
        pButton
        (click)="editPoeSurveyCancel()"
        class="ui-button-secondary flat fl-rt">
        Cancel
      </button>
      <button
        type="submit"
        pButton
        (click)="onSubmitPOESurvey()"
        class="flat btnmr fl-rt">
        Save
      </button>
    </div>
  }
  <div class="ui-g-1 edit-history-icon">
    <span
      class="fa fa-pencil ico cpointer fl-rt"
      pTooltip="Edit"
      (click)="editPoeSurvey()"
      (keyup.enter)="editPoeSurvey()"
      tabindex="0"
      tooltipPosition="bottom"></span>
  </div>
</div>
<form [formGroup]="formPOESurvey">
  <div class="readonlytbox">
    <div class="edittablebdr">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <th style="width: 25%">POE Status</th>
          <th style="width: 25%">POE Document Submitted Date</th>
          <th style="width: 25%">POE Completion Date</th>
          <th style="width: 25%"></th>
        </tr>
        <tr>
          <td>
            <p-select
              [options]="poeStatus"
              panelStyleClass="poe-submission-status-dropdown"
              [readonly]="isReadonlyPOESurvey"
              [class.readonlydd]="isReadonlyPOESurvey === true"
              formControlName="PoeStatus1"
              placeholder="--SELECT--"
              optionLabel="poeStatusName"></p-select>
          </td>
          <td>
            <p-datepicker
              formControlName="poeDocumentSubmittedDate"
              dateFormat="mm/dd/yy"
              [readonlyInput]="true"
              [showOnFocus]="false"
              [showIcon]="isReadonlyPOESurvey === false"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyPOESurvey === true"
              [defaultDate]="maxYearDate">
            </p-datepicker>
          </td>
          <td>
            <p-datepicker
              formControlName="pOECompletionDate"
              dateFormat="mm/dd/yy"
              [readonlyInput]="true"
              [showOnFocus]="false"
              [showIcon]="isReadonlyPOESurvey === false"
              [iconDisplay]="'input'"
              [class.readonlycaltb]="isReadonlyPOESurvey === true"
              [defaultDate]="maxYearDate"></p-datepicker>
          </td>
          <td></td>
        </tr>
      </table>
    </div>

    @if (poeNominationRequiredDocuments) {
      <div class="edittablebdr">
        <div class="ui-g">
          <div class="ui-g-12 ui-md-12 ui-lg-12 poe-doc-head">
            <div class="hdbl">Required Documentation</div>
          </div>
        </div>

        <input type="hidden" formControlName="poeDocs" />
        <input type="hidden" formControlName="poeInvoiceDocId" />
        <p-table [value]="poeNominationRequiredDocuments">
          <ng-template #header let-columns>
            <tr>
              <th style="width: 20%">Document Name</th>
              <th style="width: 10%">Download</th>
              <th style="width: 10%">Preview</th>
              <th style="width: 15%">Upload Date</th>
              <th style="width: 15%">Type</th>
              <th style="width: 20%">Status</th>
              <th style="width: 30%">Reason</th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr>
              <td>
                @if (rowData.filePath) {
                  <a
                    class="doc-name"
                    href="{{ rowData.filePath }}"
                    target="_blank"
                    >{{ rowData.fileName }}</a
                  >
                }
                @if (!rowData.filePath) {
                  <span>{{ rowData.documentName }}</span>
                }
              </td>
              <td>
                @if (rowData.filePath) {
                  <span
                    class="fa fa-download ico cpointer"
                    pTooltip="Download"
                    (click)="downloadPOE(rowData)"
                    (keydown.enter)="downloadPOE(rowData)"
                    tabindex="0"
                    tooltipPosition="bottom"></span>
                }
              </td>
              <td>
                @if (rowData.filePath) {
                  <a
                    class="ml-2"
                    (click)="previewInvoice(rowData)"
                    (keydown.enter)="previewInvoice(rowData)"
                    tabindex="0">
                    <i class="fa fa-file fa-lg" pTooltip="Preview"></i
                  ></a>
                }
              </td>
              <td>{{ rowData.uploadDate | date: 'MM/dd/yyyy' }}</td>
              <td>
                {{ checkPoeDocumentType(rowData.documentId) }}
              </td>
              @if (
                rowData.documentId ===
                DocumentTypesValue.DealAssociationTemplate
              ) {
                <td>
                  <p-select
                    [options]="PoeDocStatus"
                    [readonly]="isReadonlyPOESurvey"
                    [class.readonlydd]="isReadonlyPOESurvey === true"
                    #selfRef
                    formControlName="poeDOCstatusCn"
                    placeholder="--SELECT--"
                    optionLabel="poeDocStatusName"></p-select>
                </td>
              }

              <td>
                @if (
                  rowData.documentId ===
                  DocumentTypesValue.DealAssociationTemplate
                ) {
                  <span>
                    @if (
                      formPOESurvey.controls['poeDOCstatusCn'].value
                        .poeDocStatusName === 'Rejected' &&
                      !isReadonlyPOESurvey &&
                      poeDocumentRejectionReasons
                    ) {
                      <p-multiSelect
                        appendTo="body"
                        name="poeDocRejectionList"
                        placeholder="Select reason for rejecting the document"
                        [maxSelectedLabels]="2"
                        [options]="[poeDocumentRejectionReasons.reason]"
                        optionLabel="reason"
                        formControlName="poeDocumentRejectionReasonsCtrl"></p-multiSelect>
                    }
                  </span>
                }
                @if (rowData.reasons && isReadonlyPOESurvey) {
                  <span>{{ getReasons(rowData.reasons) }}</span>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }

    @if (poeNominationDocuments) {
      <div class="edittablebdr">
        <div class="ui-g">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <div class="hdbl">Saved Documents</div>
          </div>
        </div>

        <p-table
          [value]="poeNominationDocuments.poeDocumentsHistory"
          [paginator]="true"
          [rows]="historyTableRow"
          [alwaysShowPaginator]="false">
          <ng-template #header let-columns>
            <tr>
              <th style="width: 25%">Document Name</th>
              <th style="width: 15%">Upload Date</th>
              <th style="width: 15%">Type</th>
              <th style="width: 15%">Status</th>
              <th style="width: 35%">Reason</th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr>
              <td>
                @if (rowData.filePath) {
                  <a href="{{ rowData.filePath }}" target="_blank">{{
                    rowData.fileName
                  }}</a>
                }
                @if (!rowData.filePath) {
                  <span>{{ rowData.documentName }}</span>
                }
              </td>
              <td>{{ rowData.uploadDate | date: 'MM/dd/yyyy' }}</td>
              <td>{{ checkPoeDocumentType(rowData.documentId) }}</td>
              <td>{{ rowData.status }}</td>
              <td>
                @if (rowData.reasons) {
                  <span>
                    {{ getReasons(rowData.reasons) }}
                  </span>
                }
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    }
  </div>
</form>

@if (canShowPreviewModel) {
  <app-incentive-preview
    (OnPoeDocumentReview)="reviewPoeDocument($event)"
    [incentivePreviewInput]="incentivePreviewInput"
    (closePreviewModal)="closePreview()"></app-incentive-preview>
}
